module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding@2x-f851f9e7b31548d15bd2bb3d5fee20fc.webp";